export enum CreditCardTypeEnum {
  visa,
  masterCard,
  discover,
  americanExpress,
  dinersClub,
  JCB
}
